import React, { useContext, useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid2";
import ItemPanel from "./ItemPanel";
import { WithGrow } from "@common/components/WithGrow";
import RealTimeTab from "./RealTimeTab";
import DeckboardAccordion from "@pages/Assets/Room/DetailView/DeckboardAccordion";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { ViewTabContext } from "@common/components/ListDetailViews/Layout/NavigationBar/ViewsTabs/context";
import TicketTab from "@pages/Assets/common/TicketTab";
import { MeetingTabs } from "../utils";
import MonitoringTab from "./MonitoringTab";

const DetailView = () => {
  const [accordionContent, setAccordionContent] = useState<
    React.JSX.Element | undefined
  >();
  const { detail } = useContext(RoomsRealtimeContext);
  const { selectedTab } = useContext(ViewTabContext);

  useEffect(() => {
    if (detail?.setOpenAccordion)
      detail.setOpenAccordion(
        accordionContent ? "Just need a non-empty string" : ""
      );
  }, [accordionContent]);

  const id = (detail?.meeting?.id ?? "").toString();

  const selectedView = useMemo(() => {
    switch (selectedTab) {
      case MeetingTabs.Realtime:
        return <RealTimeTab />;
      case MeetingTabs.Tickets:
        if (detail?.meeting?.id !== undefined)
          return <TicketTab id={id} type="meeting" />;
      case MeetingTabs.Monitoring:
        return <MonitoringTab />;
      default:
        return <React.Fragment />;
    }
  }, [selectedTab, detail?.meeting?.id]);

  return (
    <WithGrow
      fixed={
        <Grid
          container
          sx={{
            width: "100%",
            height: "100%",
            overflowX: "hidden",
            overflowY: "scroll",
          }}
        >
          <ItemPanel setAccordionContent={setAccordionContent} />
        </Grid>
      }
    >
      <Grid container wrap="nowrap" sx={{ width: "100%", height: "100%" }}>
        <DeckboardAccordion open={accordionContent !== undefined}>
          {accordionContent}
        </DeckboardAccordion>
        {selectedView}
      </Grid>
    </WithGrow>
  );
};

export default DetailView;
